import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { navLinks } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='bg-ink text-bone'>
            <div className='mx-auto max-w-7xl px-5 pt-20 pb-10 sm:px-8'>
                <div className='grid gap-12 lg:grid-cols-[1.4fr_1fr]'>
                    <div>
                        <p className='font-mono text-xs uppercase tracking-[0.2em] text-bone/60'>
                            Ready when you are
                        </p>
                        <h2 className='mt-4 max-w-xl font-heading text-5xl leading-[0.95] tracking-tight sm:text-6xl'>
                            Your feed deserves better than <span className='italic text-signal'>slop.</span>
                        </h2>
                        <Link
                            href='/#contact'
                            className='mt-8 inline-flex items-center gap-2 rounded-full bg-signal px-6 py-3.5 text-sm font-semibold text-ink transition-transform hover:-translate-y-0.5 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-bone'
                        >
                            Start a brief
                            <ArrowUpRight className='size-4' aria-hidden='true' />
                        </Link>
                    </div>

                    <nav aria-label='Footer' className='grid grid-cols-2 gap-8 text-sm'>
                        <div>
                            <p className='font-mono text-xs uppercase tracking-[0.2em] text-bone/50'>
                                Studio
                            </p>
                            <ul className='mt-4 space-y-3'>
                                {navLinks.map(link => (
                                    <li key={link.href}>
                                        <Link href={link.href} className='text-bone/80 transition-colors hover:text-signal'>
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <p className='font-mono text-xs uppercase tracking-[0.2em] text-bone/50'>
                                Built for
                            </p>
                            <ul className='mt-4 space-y-3 text-bone/80'>
                                <li>TikTok</li>
                                <li>Instagram Reels</li>
                                <li>Facebook</li>
                                <li>YouTube Shorts</li>
                                <li>Snapchat</li>
                            </ul>
                        </div>
                    </nav>
                </div>

                <div className='mt-20 flex flex-col gap-4 border-t border-bone/15 pt-8 text-xs text-bone/50 sm:flex-row sm:items-center sm:justify-between'>
                    <p className='font-heading text-[clamp(4rem,16vw,11rem)] leading-[0.8] tracking-tight text-bone/90' aria-hidden='true'>
                        Un<span className='italic text-signal'>slop</span>
                    </p>
                    <p>
                        <span suppressHydrationWarning>
                            {new Date().getFullYear()}
                        </span>
                        {' '}Unslop Studio. Human-directed AI ads.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
